/**
 * @generated SignedSource<<3890de4b26965533101880fcbb43d582>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateProductInput = {
  category?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  dailyRate?: number | null | undefined;
  forProductId?: string | null | undefined;
  make?: string | null | undefined;
  model?: string | null | undefined;
  name?: string | null | undefined;
  notes?: string | null | undefined;
  packSize?: string | null | undefined;
  price?: number | null | undefined;
  productId: string;
  properties?: any | null | undefined;
  quantityOnHand?: number | null | undefined;
  rentable?: boolean | null | undefined;
  reorderLevel?: number | null | undefined;
  unit?: string | null | undefined;
};
export type OpsProductsPageUpdateMutation$variables = {
  input: UpdateProductInput;
};
export type OpsProductsPageUpdateMutation$data = {
  readonly updateProduct: {
    readonly product: {
      readonly id: string;
      readonly lowStock: boolean;
      readonly reorderLevel: number;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsProductsPageUpdateMutation = {
  response: OpsProductsPageUpdateMutation$data;
  variables: OpsProductsPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateProductPayload",
    "kind": "LinkedField",
    "name": "updateProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reorderLevel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lowStock",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsProductsPageUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsProductsPageUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "da9cb65cd36d0cd1e28c6664c77d2b0c",
    "id": null,
    "metadata": {},
    "name": "OpsProductsPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsProductsPageUpdateMutation(\n  $input: UpdateProductInput!\n) {\n  updateProduct(input: $input) {\n    product {\n      id\n      reorderLevel\n      lowStock\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "30dc0d34b3c225329e7fe5d68500fa96";

export default node;
